import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25cab224&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=25cab224&prod&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=25cab224&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cab224",
  null
  
)

export default component.exports